// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-column--select {
  min-width: 53px;
  max-width: 53px;
}

.mat-column--uid {
  min-width: 220px;
  max-width: 220px;
}

.mat-column--status {
  min-width: 140px;
  max-width: 140px;
}

.mat-mdc-header-cell,
.mat-mdc-cell {
  justify-content: center;
  text-align: center;
  word-break: break-word;
  -webkit-user-select: none;
          user-select: none;
  font-size: 14px;
  line-height: 24px;
}

.mat-mdc-header-cell:first-of-type,
.mat-mdc-cell:first-of-type {
  padding-left: 0;
}

.mat-mdc-header-cell:last-of-type,
.mat-mdc-cell:last-of-type {
  padding-right: 16px;
}

.mat-mdc-menu-item .mat-icon {
  margin-left: 16px;
  margin-right: 0;
}

:host ::ng-deep.mat-mdc-paginator .mat-mdc-paginator-container {
  justify-content: center;
}

:host ::ng-deep.my-header-cell .mat-sort-header-container {
  margin-left: 18px;
}

@media (min-width: 768px) and (min-height: 768px) {
  .scroll-parent {
    position: relative;
    height: 100%;
  }
  .scroll-child {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/base/table/table.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,eAAA;AACJ;;AACA;EACI,gBAAA;EACA,gBAAA;AAEJ;;AAAA;EACI,gBAAA;EACA,gBAAA;AAGJ;;AAAA;;EAEI,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;EACA,iBAAA;AAGJ;;AADA;;EAEI,eAAA;AAIJ;;AAFA;;EAEI,mBAAA;AAKJ;;AAFA;EACI,iBAAA;EACA,eAAA;AAKJ;;AAFA;EACI,uBAAA;AAKJ;;AAFA;EACI,iBAAA;AAKJ;;AAFA;EACI;IACI,kBAAA;IACA,YAAA;EAKN;EAHE;IACI,kBAAA;IACA,WAAA;IACA,YAAA;IACA,cAAA;EAKN;AACF","sourcesContent":[".mat-column--select {\n    min-width: 53px;\n    max-width: 53px;\n}\n.mat-column--uid {\n    min-width: 220px;\n    max-width: 220px;\n}\n.mat-column--status {\n    min-width: 140px;\n    max-width: 140px;\n}\n\n.mat-mdc-header-cell,\n.mat-mdc-cell {\n    justify-content: center;\n    text-align: center;\n    word-break: break-word;\n    user-select: none;\n    font-size: 14px;\n    line-height: 24px;\n}\n.mat-mdc-header-cell:first-of-type,\n.mat-mdc-cell:first-of-type {\n    padding-left: 0;\n}\n.mat-mdc-header-cell:last-of-type,\n.mat-mdc-cell:last-of-type {\n    padding-right: 16px;\n}\n\n.mat-mdc-menu-item .mat-icon {\n    margin-left: 16px;\n    margin-right: 0;\n}\n\n:host ::ng-deep.mat-mdc-paginator .mat-mdc-paginator-container {\n    justify-content: center;\n}\n\n:host ::ng-deep.my-header-cell .mat-sort-header-container {\n    margin-left: 18px;\n}\n\n@media (min-width: 768px) and (min-height: 768px) {\n    .scroll-parent {\n        position: relative;\n        height: 100%;\n    }\n    .scroll-child {\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        overflow: auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
